import { useQuery } from '@tanstack/react-query';
import { teamRepository } from '../repositories/team.repository';
import { orgKeys } from '../services/organization.keys';
import type { UserOrganization } from '../types/organization.types';

export function useUserOrganizations() {
  return useQuery({
    queryKey: orgKeys.userOrgs(),
    queryFn: async (): Promise<UserOrganization[]> => {
      return teamRepository.getUserOrganizations();
    },
    enabled: true,
  });
}
